import './polyfile';
import React from 'react';
import ReactDOM from 'react-dom';
import { store } from './store/store.index';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { Provider } from 'mobx-react';
import './index.css';
import { getQueryVariable, isFromSharePointFn, } from 'Utils/utils';
import cookie from '@foxit/sso_cookie'
cookie.setCookie('product_name', 'cloudedit');
import { localToGlobal } from './store/services';
// import UploadFilePage from 'Pages/upload-file-page/index';

// For Plugin API getAppColors
import './getAppColors.scss';

// import { getCLS, getFID, getLCP } from 'web-vitals';
import beforeRenderApp from './utils/beforeRenderApp';
// 这里特殊处理当链接携带渠道?from=pdf365/?refer=bd 信息时，将agent等于 baidu365 写入cookies
if(window.location.search.includes("from=pdf365/?refer=bd")) {
  cookie.setCookie('agent', 'baidu365');
}

// function sendToGoogleAnalytics({ name, delta, id }) {
//   // Assumes the global `gtag()` function exists, see:
//   // https://developers.google.com/analytics/devguides/collection/analyticsjs
//   gtag('event', name, {
//     event_category: 'Web Vitals',
//     event_label: id,
//     value: Math.round(name === 'CLS' ? delta * 1000 : delta),
//     nonInteraction: true,
//     transport: 'beacon',
//   });
// }

// getCLS(sendToGoogleAnalytics);
// getFID(sendToGoogleAnalytics);
// getLCP(sendToGoogleAnalytics);
  
(function prepareForOtherPlatformFlow() {
  const oneDriveState = getQueryVariable('oneDriveState');
  const docId = getQueryVariable('docidForOffice');

  if (oneDriveState || docId) {
    store.appStore.showLoading(true);
  }

  const isFromSharePoint = isFromSharePointFn()

  if (isFromSharePoint) {
    store.appStore.updateSharePointInfo({isFromSharePoint: true})
  }
})();

window._____APP_STATE_____ = store;
window._____LOCALE_TO_GLOBAL_____ = localToGlobal;
//window._____APP_STATE_____['events'] = events;
window.platform = 'PhantomOnline';
if (process.env.NODE_ENV == 'development') {
  window.__debug__ = {};
}
if (!window.__hashVersion__ || window.__hashVersion__.length < 8) {
  window.__hashVersion__ = '' + Date.now();
}


// network status
window.__online__ = true;
// window.addEventListener('offline', (/* e */) => { window.__online__ = false; })
// window.addEventListener('online', (/* e */) => { window.__online__ = true; })


beforeRenderApp().then(() => {
      //ReactDOM.render(<App />, document.getElementById('root'));
      // babel ... spread syntax https://redux.js.org/recipes/usingobjectspreadoperator  https://www.npmjs.com/package/babel-plugin-transform-object-rest-spread
      ReactDOM.render(
        <Provider {...store}>
          <App />
        </Provider>,
        document.getElementById('root'),
      );
    })
    .catch((err) => {
      store.appStore.updateLoading(false);
      store.appStore.showMessageDlg({ msg: { id: 'Error:404' } });
      console.error(err);
    });

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
//serviceWorker.unregister();
if (/* !isMobile() && */ getQueryVariable('pwa') !== 'disabled' && process.env.NODE_ENV != 'development') {
  serviceWorker.register();
  store.appStore.doListenPWAsEvents();
}

if (isEnableOnlineARIA) {
  document.documentElement.setAttribute('enable-online-aria', true);
}
